import { ToastProgrammatic } from '@akerolabs/akero-vue/src/components/toast'

/**
 * @description Updates the url with the current tab to allow for reloading
 * @param {String} tab
 */
export function setTabHistory(tab) {
  const url = window.location.href.split('?')[0]
  window.history.replaceState(null, null, `${url}?tab=${tab}`)
}

/**
 * @description Gets the 'tab' from the url search to allow tab to reload on previous one after refresh
 * @return {Number}
 */
export function getTab() {
  const tabs = {
    preview: 0,
    invited: 1,
    completed: 2,
  }
  if (!window || !window.location) return 0
  const query = new URLSearchParams(window.location.search)
  const search = {}
  for (const pair of query.entries()) {
    search[pair[0]] = pair[1]
  }
  if (Object.prototype.hasOwnProperty.call(tabs, search.tab)) {
    return tabs[search.tab]
  }
  return 0
}

/**
 * @description Create a success toast message
 * @param {String} message
 */
export function success(message) {
  ToastProgrammatic.open({
    message,
    type: 'success',
  })
}

/**
 * @description Create an error toast message
 * @param {String} message
 * @param {Error} exception
 */
export function error(message, exception = null) {
  ToastProgrammatic.open({
    message,
    type: 'danger',
  })
  if (exception) {
    console.log(exception)
  }
}
